module.exports = require("css.escape");


//////////////////
// WEBPACK FOOTER
// external "css.escape"
// module id = 484
// module chunks = 0